import React, { useState } from 'react';

const ShopSettingsEditor = ({ shopItems, setShopItems, ranks }) => {
    const [isOpen, setIsOpen] = useState(false);

    const addItem = () => {
        const newId = 'item_' + Date.now();
        setShopItems([...shopItems, { 
            id: newId, 
            name: '新規商品', 
            price: 1000, 
            currency: 'JPY',
            description: '',
            imageUrl: '', 
            validityLabel: '有効: 無期限',
            periodDays: 0, 
            type: 'item', 
            targetId: '', 
            icon: '🎁'
        }]);
        setIsOpen(true);
    };

    const updateItem = (index, key, value) => {
        const newItems = [...shopItems];
        newItems[index][key] = value;
        setShopItems(newItems);
    };

    const removeItem = (index) => {
        if(window.confirm('この商品を削除しますか？')) {
            const newItems = [...shopItems];
            newItems.splice(index, 1);
            setShopItems(newItems);
        }
    };

    return (
        <div style={{marginBottom:'20px', border:'1px solid #ddd', borderRadius:'8px', background:'white', overflow:'hidden'}}>
            <div 
                onClick={() => setIsOpen(!isOpen)} 
                style={{
                    padding:'15px', background:'#f5f5f5', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', fontWeight:'bold'
                }}
            >
                <span>🛒 ショップ商品設定 ({shopItems.length})</span>
                <span>{isOpen ? '▲ 閉じる' : '▼ 開く'}</span>
            </div>
            
            {isOpen && (
                <div style={{padding:'15px'}}>
                    <div style={{fontSize:'11px', color:'#666', marginBottom:'10px'}}>
                        ここで設定した商品が「ショップ」に表示されます。
                    </div>
                    
                    {shopItems.map((item, i) => (
                        <div key={item.id} style={{marginBottom:'15px', background:'#fff', padding:'10px', borderRadius:'6px', border:'1px solid #eee', boxShadow:'0 1px 3px rgba(0,0,0,0.1)'}}>
                            <div style={{display:'flex', gap:'5px', marginBottom:'5px', alignItems:'center'}}>
                                <div style={{fontWeight:'bold', color:'#999', fontSize:'12px'}}>#{i+1}</div>
                                <input type="text" value={item.icon} onChange={e=>updateItem(i, 'icon', e.target.value)} style={{width:'40px', textAlign:'center'}} placeholder="絵" />
                                <input type="text" value={item.name} onChange={e=>updateItem(i, 'name', e.target.value)} style={{flex:1}} placeholder="商品名" />
                                <button onClick={()=>removeItem(i)} style={{background:'#ffcdd2', color:'#c62828', border:'none', borderRadius:'4px', padding:'5px', fontSize:'12px'}}>削除</button>
                            </div>
                            
                            <div style={{marginBottom:'5px'}}>
                                <label style={{fontSize:'10px', display:'block'}}>商品画像 URL (任意)</label>
                                <input type="text" value={item.imageUrl} onChange={e=>updateItem(i, 'imageUrl', e.target.value)} placeholder="https://.../photo.jpg" style={{width:'100%'}} />
                            </div>

                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'5px', marginBottom:'5px'}}>
                                <div>
                                    <label style={{fontSize:'10px', display:'block'}}>価格 (円 or P)</label>
                                    <input type="number" value={item.price} onChange={e=>updateItem(i, 'price', Number(e.target.value))} style={{width:'100%'}} />
                                </div>
                                <div>
                                    <label style={{fontSize:'10px', display:'block'}}>支払い方法</label>
                                    <select value={item.paymentMethod || 'paypay'} onChange={e=>updateItem(i, 'paymentMethod', e.target.value)} style={{width:'100%'}}>
                                        <option value="paypay">📱 PayPay</option>
                                        <option value="bank">🏦 銀行振込</option>
                                        <option value="point">🪙 RBコイン</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{fontSize:'10px', display:'block'}}>種類</label>
                                    <select value={item.type} onChange={e=>updateItem(i, 'type', e.target.value)} style={{width:'100%'}}>
                                        <option value="item">グッズ/アイテム</option>
                                        <option value="rank">ランク/権限付与</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{marginBottom:'5px'}}>
                                <label style={{fontSize:'10px', display:'block'}}>ID (システム管理用)</label>
                                {item.type === 'rank' ? (
                                    <select value={item.targetId} onChange={e=>updateItem(i, 'targetId', e.target.value)} style={{width:'100%'}}>
                                        <option value="">選択してください</option>
                                        {ranks.map(r => <option key={r.id} value={r.id}>{r.icon} {r.name}</option>)}
                                    </select>
                                ) : (
                                    <input type="text" value={item.targetId} onChange={e=>updateItem(i, 'targetId', e.target.value)} placeholder="例: uniform_2024" style={{width:'100%'}} />
                                )}
                            </div>

                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px', marginBottom:'5px'}}>
                                <div>
                                    <label style={{fontSize:'10px', display:'block'}}>有効期間 (日数, 0=無期限)</label>
                                    <input type="number" value={item.periodDays} onChange={e=>updateItem(i, 'periodDays', Number(e.target.value))} style={{width:'100%'}} />
                                </div>
                                <div>
                                    <label style={{fontSize:'10px', display:'block'}}>プロフィール表示文言</label>
                                    <input type="text" value={item.validityLabel} onChange={e=>updateItem(i, 'validityLabel', e.target.value)} placeholder="例: 有効: 無期限" style={{width:'100%'}} />
                                </div>
                            </div>

                            <div>
                                <label style={{fontSize:'10px', display:'block'}}>説明文</label>
                                <input type="text" value={item.description} onChange={e=>updateItem(i, 'description', e.target.value)} placeholder="商品の説明" style={{width:'100%'}} />
                            </div>
                        </div>
                    ))}
                    
                    <button onClick={addItem} className="btn btn-sm btn-primary" style={{width:'100%', marginTop:'5px', padding:'10px'}}>
                        + 商品を追加
                    </button>
                </div>
            )}
        </div>
    );
};

export default ShopSettingsEditor;